<script setup>
import LoginPage from "@/pages/login-page.vue";
</script>

<template>
  <div class="main">
    <login-page />
  </div>
</template>

<style lang="scss">

</style>